import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SparringpartnerComponent } from './sparringpartner.component';
import { SharedModule } from '../shared/shared.module';
import { AutoResizeDirective } from './auto-resize.directive';
import { SurveyComponent } from './survey/survey.component';
import { InactivityTimerComponent } from './inactivity-timer/inactivity-timer.component';
import { InactivityTimerService } from './inactivity-timer.service';
import { ThuisartsArticleComponent } from './thuisarts-article/thuisarts-article.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SparringpartnerComponent,
    AutoResizeDirective,
    SurveyComponent,
    InactivityTimerComponent,
    ThuisartsArticleComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
  ],
  providers: [
    InactivityTimerService,
  ],
  exports: [
    SparringpartnerComponent,
  ],
})
export class SparringpartnerModule {}
